<script>
  import { onMount } from "svelte";
  let timer;
  let loaded = false;
  const writeSKWidget = () => {
    const script = document.createElement("script");
    script.setAttribute("src", "//widget.songkick.com/10208446/widget.js");
    document.getElementsByTagName("body")[0].appendChild(script);
  };
  const isLoaded = () => {
    timer = window.setInterval(() => {
      const a = document.getElementById("songkick-widget-link");
      if (!a) {
        window.clearInterval(timer);
        setTimeout(() => {
          loaded = true;
        }, 800);
      }
    }, 500);
  };

  onMount(async () => {
    isLoaded();
    writeSKWidget();
  });
</script>

{#if !loaded}
  <div>
    <p>Loading...</p>
  </div>
{/if}

<div id="songkick-widget">
  <a href="https://www.songkick.com/artists/10208446" class="songkick-widget" data-theme="light" data-track-button="on" data-detect-style="true" data-background-color="transparent" data-locale="en">Country Cruel tour dates</a>
</div>
